import { render, staticRenderFns } from "./appLanguages.vue?vue&type=template&id=f8c7040c&"
import script from "./appLanguages.vue?vue&type=script&lang=js&"
export * from "./appLanguages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports